export default "__VITE_ASSET__58199754__"